import React, { useState } from 'react'
import {Link} from 'react-router-dom'
import './style.css'

const Hero = (props) => {
    const [showVideo, setShowVideo] = useState(false);

    const openVideoPlayer = () => {
        setShowVideo(true);
    }

    const closeVideoPlayer = () => {
        setShowVideo(false);
    }
    
    // Close video when clicking outside the video content
    const handleModalClick = (e) => {
        if (e.target.className === 'video-modal') {
            closeVideoPlayer();
        }
    }

    return(
        <section  className={`hero ${props.HeroStyleClass}`}>
            <div className="hero-slider">
                <div className="slide">
                    <div className="container">
                        <div className="row">
                            <div className="col col-lg-7 slide-caption">
                                <div className="slide-top">
                                    <span>Quran Learning for Everyone</span>
                                </div>
                                <div className="slide-title">
                                    <h2>Dar-ul-Quran Academy</h2>
                                </div>
                                <div className="slide-subtitle">
                                    <p>UK-based online Quran learning platform dedicated to providing high-quality Islamic education for children and adults.</p>
                                </div>
                                <div className="btns">
                                    <a href="#booking-form" className="theme-btn"><h4>Book a Free Demo Class</h4></a>
                                    <button onClick={openVideoPlayer} className="theme-btn"><h4>Watch Video</h4></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="right-vec">
                        <img src={props.heroImg} alt=""/>
                        <div className="right-border">
                            <div className="right-icon"><i className="fi flaticon-allah-word"></i></div>
                            <div className="right-icon"><i className="fi flaticon-taj-mahal-1"></i></div>
                            <div className="right-icon"><i className="fi flaticon-quran"></i></div>
                            <div className="right-icon"><i className="fi flaticon-business-and-finance"></i></div>
                            <div className="right-icon"><i className="fi flaticon-prayer"></i></div>
                            <div className="right-icon"><i className="fi flaticon-muhammad-word"></i></div>
                        </div>
                    </div>
                </div>
            </div>
            {showVideo && (
                <div className="video-modal" onClick={handleModalClick}>
                    <div className="video-modal-content">
                        <button className="close-video" onClick={closeVideoPlayer}>&times;</button>
                        <div className="video-container">
                            <iframe 
                                width="100%" 
                                height="100%" 
                                src="https://www.youtube.com/embed/lBSReBcJjqs" 
                                title="Dar-ul-Quran Academy Video" 
                                frameBorder="0" 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                allowFullScreen>
                            </iframe>
                        </div>
                    </div>
                </div>
            )}
        </section>
    )
}

export default Hero;